import axios from "./Api";

export const GetWarehouseList = async () => {
  const url = `/api/app/warehouse`;
  const data = await axios.get(url);
  return data;
};

export const AddWarehouse = async (params: any) => {
  const url = `/api/app/warehouse`;
  const data = await axios.post(url, params);
  return data;
};

export const EditWarehouse = async (params: any, id: number) => {
  const url = `/api/app/warehouse/${id}`;
  const data = await axios.put(url, params);
  return data;
};

export const DeleteWarehouse = async (id: number) => {
  const url = `/api/app/warehouse/${id}`;
  const data = await axios.delete(url);
  return data;
};
